import { OnInit } from '@angular/core';
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HtmlBase, BObjectModel, PropertyData, QueovalItemModel, QueovalItem, BObjectSummary, QueovalDate, Select } from '../../../../../models';
import { CoreService, HttpService, QueovalDateService } from '../../../../../services';
import { ToastService } from '../../../../../toast';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-cycle-elearning',
  templateUrl: './cycle-elearning.component.html',
  styleUrls: ['./cycle-elearning.component.css', '../../../dynamictag.component.css']

})

export class CycleElearningComponent implements OnInit {

  // #region VARIABLES GLOBALES

  // #region public
  public dateExpiration: QueovalDate;
  public displayModeAjoutUniquement: boolean = true;
  public valueModeAjoutUniquement: boolean = true;

  public cyclesEl: Array<QueovalItem> = [];
  public apprenants: Array<QueovalItem> = [];

  public idUser: string = '0';
  public idStage: string = '0';
  // #endregion

  // #region private

  // #endregion

  // #endregion

  // #region DIRECTIVES
  @Input('idUser') set SetIdUser(value: string) {
    if (value)
      this.idUser = value
  }
  @Input('idStage') set SetIdStage(value: string) {
    if (value)
      this.idStage = value
  }
  @Input('model') model: BObjectModel = new BObjectModel();

  @Input('listApprenant') set SetListApprenants(value: Array<QueovalItem>) {
    if (value)
      this.apprenants = value;
  }

  @Output('save') save: EventEmitter<void> = new EventEmitter<void>(false);
  //   // #endregion

  // #region CONSTRUCTEUR
  constructor(
    private toastservice: ToastService,
    private indParam: CoreService,
    private http: HttpService,
    public sanitizer: DomSanitizer,
    public qDateService: QueovalDateService,
  ) { }
  //   // #endregion

  log(e: any): void {
    console.log(e);
  }

  // #region FONCTIONS PUBLIQUES
  public ngOnInit(): void {
    if (this.idStage == '0') {
      this.http.getHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem/getData/DATE_EXPIRATION_STAGE/${this.idUser}`).subscribe(
        (result: QueovalItemModel) => {
          if (result.Date)
            this.dateExpiration = this.qDateService.FromDate(new Date(result.Date.toString()));
          else
            this.dateExpiration = new QueovalDate();
        })
    }

    if (this.idUser != '0') {
      this.displayModeAjoutUniquement = false;
      this.http.getHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem/getData/LISTE_CYCLES_EL_PAR_APPERNANT/${this.idUser}`).subscribe(
        (result: QueovalItemModel) => {
          this.cyclesEl = result.queovalItemList;
        });
    } else if (this.idStage != '0') {
      this.http.getHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem/getData/LISTE_CYCLES_EL_PAR_STAGE/${this.idStage}`).subscribe(
        (result: QueovalItemModel) => {
          this.cyclesEl = result.queovalItemList;
        })
      if (this.apprenants.length == 0) {
        this.http.getHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem/getData/LISTE_APPERNANT_PAR_STAGE/${this.idStage}`).subscribe(
          (result: QueovalItemModel) => {
            this.apprenants = result.queovalItemList;
          })
      }
    }
  }
  public OnCheckAll(): void {
    let value = false;
    if (!this.CheckAllIsChecked()) {
      value = true;
    }
    this.cyclesEl.forEach(cycle => cycle.Selected = value);
  }
  public CheckAllIsChecked(): boolean {
    return this.cyclesEl.filter(cycle => !cycle.Selected).length == 0
  }

  public OnCheckAllApprenant(): void {
    let value = false;
    if (!this.CheckAllApprenantIsChecked()) {
      value = true;
    }
    this.apprenants.forEach(apprenant => apprenant.Selected = value);
  }

  public CheckAllApprenantIsChecked(): boolean {
    return this.apprenants.filter(apprenant => !apprenant.Selected).length == 0
  }

  public OnSave(): void {
    const model: QueovalItemModel = new QueovalItemModel();
    model.Mode = 'AFFECT_CYCLE_EL_TO_USER';
    model.queovalItemList = this.cyclesEl.filter(cycle => cycle.Selected);
    model.Boolean = this.displayModeAjoutUniquement && this.valueModeAjoutUniquement;
    model.Boolean2 = false;
    if (!this.dateExpiration || this.dateExpiration.annee === '0' || this.dateExpiration.mois === '0' || this.dateExpiration.jour === '0') {
      model.Date = null as any;
    } else {
      const strYear: string = Number(this.dateExpiration.annee) < 10 ? `000${this.dateExpiration.annee}` : Number(this.dateExpiration.annee) < 100 ? `00${this.dateExpiration.annee}` : Number(this.dateExpiration.annee) < 1000 ? `0${this.dateExpiration.annee}` : this.dateExpiration.annee;
      const strDay: string = Number(this.dateExpiration.jour) < 10 ? `0${Number(this.dateExpiration.jour)}` : this.dateExpiration.jour;
      const strMonth: string = Number(this.dateExpiration.mois) < 10 ? `0${Number(this.dateExpiration.mois)}` : this.dateExpiration.mois;
      model.Date = new Date(`${strYear}-${strMonth}-${strDay}`);
    }
    this.indParam.showSplash(true);
    if (this.idUser != '0') {
      model.Ident = this.idUser;
      this.http.postHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem`, model).subscribe(
        (response: QueovalItemModel) => {
          this.indParam.showSplash(false);
          response.queovalItemList.forEach((item: QueovalItem) => {
            const summary: BObjectSummary[] = this.model.summary.filter((el: BObjectSummary) => {
              return el.ColumnName == item.Text || el.ColumnsIds.includes(item.Text)
            });
            if (summary && summary.length == 1) {
              const prop: PropertyData = this.model.Body.SelectedGroupsList[summary[0].IndexGroupsList].DataList[summary[0].IndexDataList];
              let index: number = prop.MainElementList.findIndex(element => element.ID == item.Text);
              index = index == -1 ? 0 : index;
              if (prop.MainElementList[index].TagName == 'DATEPICKER' || prop.MainElementList[index].TagName == 'DATEHOURPICKER') {
                try {
                  if (item.Value) {
                    const dt: Date = new Date(Date.parse(item.Value));
                    prop.MainElementList[index].Value = `${dt.getDate()}/${dt.getMonth() + 1}/${dt.getFullYear()}`;
                  }
                  else {
                    prop.MainElementList[index].Value = '00/00/0000';
                  }
                  this.model.Body.SelectedGroupsList[summary[0].IndexGroupsList].DataList[summary[0].IndexDataList] = JSON.parse(JSON.stringify(prop));
                } catch (ex) {

                }
              }
              prop.MainElementList[index].Value = item.Value;
              if (prop && prop.MainElementList[index].SelectOptionsList && prop.MainElementList[index].SelectOptionsList.length > 0) {
                prop.MainElementList[index].SelectOptionsList.forEach((option: QueovalItem) => {
                  if (option.Value == prop.MainElementList[index].Value) {
                    option.Selected = true;
                  } else {
                    option.Selected = false;
                  }
                })
              }
            }
          });


          this.save.emit();
        }
      );
    }
    else if (this.idStage != '0') {
      model.Boolean2 = true;
      this.apprenants.forEach(apprenant => {
         if (apprenant.Selected) {
            model.Ident = apprenant.Value;
            this.http.postHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem`, model).subscribe(
              () => {
                this.indParam.showSplash(false);
                this.save.emit();
              }
              );
         }
      })
    } else {
      this.indParam.showSplash(false);
    }
  }
  // #endregion

  // #region FONCTIONS PRIVEES
  
  // #endregion
}

